// @ts-check
import { createDataGridContext } from '~/components/Shared/ZeroDataGrid/ZeroDataGrid.context';
import { useContext } from "react";

export const [AssignmentDataGridContext, AssignmentDataGridContextProvider] = createDataGridContext('assignments');

/** @returns {BaseDataGridContextValue} */
export function useAssignmentDataGridContext() {
    return useContext(AssignmentDataGridContext);
} 